import React from 'react';
import { DollarSign, Loader2 } from 'lucide-react';
import { AverageFeeMetrics } from '@/types/savingsCalculator';

interface AverageFeeCardsProps {
  data: AverageFeeMetrics;
  loading?: boolean;
}

const fmt = (amount: number) =>
  amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const AverageFeeCards: React.FC<AverageFeeCardsProps> = ({ data, loading = false }) => {
  const cards = [
    {
      label: 'Average Fees Per Transaction',
      value: data.avgFeePerTransaction,
      subtitle: 'Across all card transactions',
    },
    {
      label: 'Average Fees Per Customer',
      value: data.avgFeePerCustomer,
      subtitle: 'Across all customers',
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="border-2 border-muted rounded-xl bg-white dark:bg-background p-5 flex items-center justify-between"
        >
          {loading ? (
            <div className="flex items-center justify-center w-full py-2">
              <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
            </div>
          ) : (
            <>
              <div>
                <p className="text-sm text-muted-foreground">{card.label}</p>
                <p className="text-2xl font-bold text-foreground">${fmt(card.value)}</p>
                <p className="text-xs text-muted-foreground">{card.subtitle}</p>
              </div>
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-50 dark:bg-blue-950 shrink-0">
                <DollarSign className="h-5 w-5 text-blue-500" />
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AverageFeeCards;
